<template>
  <OmtStickedModal data-cy="feedback-modal" @close="$emit('close')">
    <CBox min-height="60vh">
      <OmtTypography v-if="type === 'renovar'" as="h1-bold"
mb="32px"> Renovar autorização </OmtTypography>
      <OmtTypography v-else as="h1-bold"
mb="32px"> Autorizar administração </OmtTypography>

      <OmtTypography as="p1">
        A autorização deste contato como administrador da sua conta é necessária para manter a sua
        segurança.</OmtTypography
      >
      <OmtTypography as="h3-bold" py="16px">
        Selecione o período em que você deseja renovar esta autorização:
      </OmtTypography>
      <OmtTypography as="p1"> Revalidação obrigatória</OmtTypography>

      <CFlex py="16px" justifyContent="space-between">
        <CBox width="48%"
          ><OmtButton :variant="selectedPeriod === 'A' ? 'solid' : 'outline'" w="100%"
@click="selectedPeriod = 'A'"
            >Anual</OmtButton
          ></CBox
        >
        <CBox width="48%"
          ><OmtButton :variant="selectedPeriod === 'S' ? 'solid' : 'outline'" w="100%"
@click="selectedPeriod = 'S'"
            >Semestral</OmtButton
          ></CBox
        >
      </CFlex>
    </CBox>
    <template #footer>
      <OmtButton w="100%" @click="$emit('' + type, { ...value, Revalidacao: selectedPeriod })">Salvar</OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
      default: ""
    },
    value: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedPeriod: "S"
    };
  },
  computed: {
    htmlCardDescription() {
      if (!this.cardDescription) return false;
      return this.cardDescription.includes("<");
    },
    cardDescriptions() {
      return this.cardDescription?.split("|") || "";
    }
  }
};
</script>
